import * as config from '../../config';

export default {
  ...config,
  API_ROOT_URL: config.HOST + config.ROOT_URL + config.BACKEND_ADMIN_URL,
};



// WEBPACK FOOTER //
// ./src/frontend/admin/config.js